export default {
  authUser(state, data) {
    state.token = data.token;
  },

  setUploadInfo(state, data) {
    state.uploadInfo = data;
  },
  setUploads(state, data) {
    state.uploads = data;
  },

  setCompanies(state, data) {
    state.companies = data;
  },
  setCompany(state, data) {
    state.company = data;
  },

  setSubSystems(state, data) {
    state.subSystems = data;
  },

  setCompanyTypes(state, data) {
    state.companyTypes = data;
  },

  setRelationFields(state, data) {
    state.relationFields = data;
  },
  setRelationTables(state, data) {
    state.relationTables = data;
  },
  setRelationForeignKeys(state, data) {
    state.relationForeignKeys = data;
  },
  setRelationParentTables(state, data) {
    state.relationParentTables = data;
  },
  setRelationChildTables(state, data) {
    state.relationChildTables = data;
  },
  setRelationParentForeignKeys(state, data) {
    state.relationParentForeignKeys = data;
  },
  setDatabases(state, data) {
    state.databases = data;
  },

  setMenus(state, data) {
    state.menus = data;
  },
  setClubPermissions(state, data) {
    state.clubPermissions = data;
  },

  setTargetBranches(state, data) {
    state.targetBranches = data;
  },
  setSourceBranches(state, data) {
    state.sourceBranches = data;
  },
  setBackupImport(state, data) {
    state.backupImport = data;
  },
  setBackupImportId(state, data) {
    state.backupImportId = data;
  },
  setBackupUploadProgress(state, data) {
    state.backupUploadProgress = data;
  },
  setBackupUploading(state, data) {
    state.backupUploading = data;
  },
  setBackupExporting(state, data) {
    state.backupExporting = data;
  },
};
